module.exports = __webpack_public_path__ + "static/marquee@2x-d5bf75a612301fbc8fe10cc8acaa4582.png";